import { getLoginData } from '../lib/APIClient'

export function fetchLoginData() {
  return (dispatch) => {
    getLoginData((e, data) => {
      if (e) {
        console.error(`Error found while fetching login data: ${  e}`)
        dispatch({ type: "LOGIN_DATA", data: {} })
      }
      else {
        dispatch({ type: "LOGIN_DATA", data })
      }
    })
  }
}

export default fetchLoginData
